module.exports = __webpack_public_path__ + "img/ryj@2x.9a05ac25.png";